import RsrCancel from "@/views/crud/modules/RsrCancel";
import RsrPenalty from "@/views/crud/modules/RsrPenalty.vue";
import ListButton from "@/views/crud/modules/ListButton";

export default {
    key: "cp_rsr_v2",
    id: "rsr_id",
    // type: "readonly",
    action: ["edit"],
    export: ["excel"],
    excel: {
        //max_row:"50000"
    },
    sort: {
        field: "rsr_id",
        order: "desc"
    },
    sort_fields: [
        "rsr_id",
        "cre_dttm",
        "lupd_dttm",
        "tran_id",
        "duration",
        "lp",
        "start_code",
        "status",
        "start_time",
        "end_time",
        "actual_end_time",
        "lp_in",
        "lp_out",
        "lp_out",
        "ev_disconnect_time",
        "in_time",
        "out_time",
        "payment_result_id",
        "penalty_mode"
    ],
    filters:{
        // id:{},
        rsr_id:{},
        external_account_id:{},
        cp_no:{
            type: "multiselect",
            value: "status",
        },
        cre_dttm: {
            type: "daterange"
        },
        status:{
            type: "select",
            value: "status"
        },
        lupd_dttm:{
            type: "daterange"
        },
        lp:{},
        stop_type:{},
        stop_reason:{},
        start_code:{},
        connector_name: {
            type: "select",
            label: "name",
            value: "connector_name",
        },
        stop_type_name: {
            type: "select",
            label: "name",
            value: "name",
        },
        loc_address: {
            type: "select",
            label: "address",
            value: "address",
        },
        payment_status_name: {
            type: "select",
            label: "name",
            value: "name"
        },
        start_time:{
            type: "daterange"
        },
        end_time:{
            type: "daterange"
        },
        actual_end_time:{
            type: "daterange"
        },
        cancel_time:{
            type: "daterange"
        },
        tran_id:{},
        payment_result_id:{},
        remarks:{},
        carpark_id:{},
        brand_in:{},
        brand_out:{},
        lp_in:{},
        lp_out:{},
        lprs_session_id:{},
        in_time:{
            type:"daterange"
        },
        out_time:{
            type:"daterange"
        },
        bay_name:{},
        penalty:{},
        penalty_mode:{
            type: "select"
        }
    },


    options: {
        cp_no: {
            key: "cps",
            label: "cp_no",
            value: "cp_no",
        },
        connector_name: {
            key: "connector",
            label: "name",
            value: "name"
        },
        stop_type_name: {
            key: "cp_rsr_stop_type",
            label: "name",
            value: "name"
        },
        loc_address: {
            key: "mall",
            label: "address",
            value: "address"
        },
        payment_status_name: {
            key: "cp_rsr_payment_status",
            label: "name",
            value: "name"
        },
        penalty_mode:{
            key: "penalty_mode",
            label: "name",
            value: "code"
        },
        status:{
            key: "cp_rsr_status",
            label: "name",
            value: "name"
        }
    },
    fields:[
        // { key: "id", field:"rsr_id", width:50},
        {key: "rsr_id", width: 50},
        { key: "external_account_id"},
        // { key: "mall_id"},
        { key: "loc_address"},
        { key: "carpark_id"},
        // {
        //     key: "bay_name",
        //     type: "href",
        //     url: "bay/",
        //     url_key: [
        //         {
        //             search_key: "id",
        //             row_key: "bay_id_int",
        //             str: ""
        //         }
        //     ]
        // },
        { key: "lprs_bay_id" },
        // { key: "bay_id"},
        { key: "cp_no"},
        { key: "connector_name"},
        { key: "status", width:80},
        { key: "payment_status_name"},
        { key: "reservation_type"},
        {key: "penalty_mode"},
        { key : "current_unit_session"},
        { key : "max_charging_unit"},
        {key: "charging_fee"},
        {key: "penalty_fee"},
        {key: "point"},
        {key: "redeem_voucher_sessions"},
        // {key: "redeem_voucher_size"},

        // { key: "connector_id", width:80},
        {
            key: "tran_id", 
            width:80,
            type: "href",
            url:"cp_sessions/",
            url_key:[
                {
                    search_key:"id_tag",
                    row_key:"rsr_id",
                    str:"RSR:"
                }
            ]
        },
        {
            key: "payment_result_id",
            type: "href",
            url: "payment_result_detail/",
            url_key: [
                {
                    search_key: "resultId",
                    row_key: "payment_result_id",
                    str: ""
                }
            ]
        },
        // tran_id:{
        //     type: "href",
        //     url:"cp_sessions/",
        //     url_key:[
        //         {
        //             key:"id_tag",
        //             str:"RSR:"
        //         }
        //     ]
        // },
        // { key: "lp", width:80},
        // { key: "start_code", width:70},
        // { key: "rate", width:70},
        // { key: "unit_in_minutes", width:100},
        { key: "duration", width:100},
        // { key: "end_time", type: "datetime"},
        { key: "stop_type_name", },
        // { key: "stop_reason", },
        { key: "start_time", type: "datetime", disabled: true},
        { key: "actual_end_time", type: "datetime"},
        { key: "cre_dttm", type: "datetime"},
        { key: "lupd_dttm", type: "datetime"},
        { key: "actual_finished_time", type: "datetime"},
        { key: "gracing_period_end_dttm", type: "datetime", disabled:true},

        { key: "cancel_time", type: "datetime"},
        { key: "lprs_session_id"},
        { key: "lprs_out_session_id"},
        { key :"brand_in"},
        { key :"lp_in"},
        { key :"brand_out"},
        {key :"lp_out"},
        {key :"in_time" ,type: "datetime"},
        {key :"out_time",type: "datetime"},
        {key :"ev_disconnect_time",type: "datetime", disabled:true},
        {key : "next_available_redeem_date",type: "datetime", privilege:["cstDebug"]},
        {key: "shk30day_redeem_count", privilege:["cstDebug"]},
        { key: "remarks"},
        { key: "cancel", type: "components", component: RsrCancel, width:50},
        // {type: "action-btn"},
        {key: "penalty_button", type: "components", component: RsrPenalty, width: 50,  privilege: ["READ_PENALTY_BUTTON"]},
        {key: "settled_button", type: "components", component: ListButton, width: 50, 
            param:{
                label:"dollar-sign",
                url:"/cp_rsr/setup_settled/",
                msg:"確定更改狀態為“Settled”?",
                post_key:[
                    {key:"rsr_id"},
                ]
            }, 
            display_param:[
                {key:"status", val:"Unsettled", type:"eq"},
                // {key:"payment_status_name", val:"Unsettled", type:"eq"},
            ],  
            privilege: ["READ_SETTLED_BUTTON"]
        },
        // {key: "is_free"}

        // { key: "uuid"},
    ],
    structure:[
        ["start_time"],
        ["gracing_period_end_dttm"],
        ["ev_disconnect_time"],
        ["actual_finished_time"],
    ]
}